import { render, staticRenderFns } from "./agentDayTrade.vue?vue&type=template&id=436358ad&scoped=true&"
import script from "./agentDayTrade.vue?vue&type=script&lang=js&"
export * from "./agentDayTrade.vue?vue&type=script&lang=js&"
import style0 from "./agentDayTrade.vue?vue&type=style&index=0&id=436358ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436358ad",
  null
  
)

export default component.exports